var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 6,
    x2: 235,
    y1: 33,
    y2: 344,
    gradientTransform: "translate(0 .937) scale(.3122)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41d1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd34fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 194.651,
    x2: 236.076,
    y1: 8.818,
    y2: 292.989,
    gradientTransform: "translate(0 .937) scale(.3122)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffea83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#ffdd35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa800"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M124.766 19.52L67.324 122.238c-1.187 2.121-4.234 2.133-5.437.024L3.305 19.532c-1.313-2.302.652-5.087 3.261-4.622L64.07 25.187a3.09 3.09 0 001.11 0l56.3-10.261c2.598-.473 4.575 2.289 3.286 4.594zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M91.46 1.43L48.954 9.758a1.56 1.56 0 00-1.258 1.437l-2.617 44.168a1.563 1.563 0 001.91 1.614l11.836-2.735a1.562 1.562 0 011.88 1.836l-3.517 17.219a1.562 1.562 0 001.985 1.805l7.308-2.223c1.133-.344 2.223.652 1.985 1.812l-5.59 27.047c-.348 1.692 1.902 2.614 2.84 1.164l.625-.968 34.64-69.13c.582-1.16-.421-2.48-1.69-2.234l-12.185 2.352a1.558 1.558 0 01-1.793-1.965l7.95-27.562A1.56 1.56 0 0091.46 1.43zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitejs);
export default __webpack_public_path__ + "static/media/Vite.js.534bbd59d9fc32b6bf9bafd9c11adc3d.svg";
export { ForwardRef as ReactComponent };